<template>
  <div>
  <message :messages="messages"></message>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <insured></insured>
        </v-flex>
        <v-flex xs12>
          <risk></risk>
        </v-flex>
        <v-flex xs12>
          <claimant></claimant>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="pt-3">
        <v-spacer></v-spacer>
        <v-btn round color="secondary" @click.prevent="doAddClaimant">
          Add Claimant
          <v-icon right dark>mdi-account-plus</v-icon>
        </v-btn>
        <v-btn round color="primary" type="submit" @click.prevent="doConfirm">
          Confirm Claim
          <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
        </v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { CLAIMS_CLAIMDETAIL_LIFECYCLE, CLAIMS_CLAIMDETAIL_SAVE_LOADING, CLAIMS_CLAIMDETAIL_SAVE_SUCCESS, CLAIMS_CLAIMDETAIL_LEAVECLAIM, CLAIMS_CLAIMDETAIL_SAVE_FAIL } from '@/store/types'
import Insured from '../query/Insured'
import Risk from '../query/Risk'
import Claimant from '../query/Claimant'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { generateCurrentForm } from '@/store/modules/claims/actions/claim'
import MessageMixin from '@/mixins/message'
import { SaveClaimMixin } from '../saveClaimMixin'

export default {
  data() {
    return {
      labels: {
        claimSummary: 'Claim Summary'
      }
    }
  },
  computed: {
    globalCommonForm() {
      return this.$store.state.claims.claimDetail.commonForm
    },
    globalClaimForm() {
      return this.$store.state.claims.claimDetail.claimForm
    },
    claimDetail() {
      return this.$store.state.claims.claimDetail
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
    },
    doAddClaimant() {
      this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 1)
      this.$router.push({ name: 'claimDetail' })
    },
    async doConfirm() {
      const apiUrl = this.claimDetail.menu.confirmClaim
      if (apiUrl) {
        try {
          this.$store.commit(CLAIMS_CLAIMDETAIL_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generateCurrentForm(this.$store.state.claims))
          this.$store.commit(CLAIMS_CLAIMDETAIL_SAVE_SUCCESS)
          this.$snotify.success('Claim has been Confirmed')

          this.$store.commit(CLAIMS_CLAIMDETAIL_LEAVECLAIM)
          if (this.claimDetail.commonForm.appID === 'MO') {
            this.$router.push({ name: 'motorClaimQuery', params: { id: result.data.clmRefNo }, query: { if: true } })
          } else if (this.claimDetail.commonForm.appID === 'TR') {
            this.$router.push({ name: 'travelClaimQuery', params: { id: result.data.clmRefNo }, query: { if: true } })
          }
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
            this.promptFieldCheck()
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(CLAIMS_CLAIMDETAIL_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('saveClaim')
        return true
      } catch (err) {
        return false
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.claims.claimDetail.claimLifeCycle !== 4) {
      this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 4)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveClaimMixin
  ],
  components: {
    Insured,
    Risk,
    Claimant
  }
}
</script>

<style lang="scss">
</style>
